import { Component } from "@angular/core";
import { BaseTimelineFilterComponent } from "../../base/timeline-filter/base-timeline-filter.component";
import { ITypeFilter } from "../../../../interfaces/i-type-filter";
import { IProjectAOI } from "../../../../interfaces/i-project-aoi";
import { FilterProjectService } from "../../../../services/internal-services/filter-project.service";
import { GoogleAnalyticsService } from "../../../../../shared/services/google-analytics.service";

@Component({
  selector: "app-projects-timeline-filter",
  templateUrl: "./projects-timeline-filter.component.html",
  styleUrls: ["../../base/timeline-filter/base-timeline-filter.component.scss"],
  standalone: false,
})
export class ProjectsTimelineFilterComponent extends BaseTimelineFilterComponent {
  constructor(googleAnalyticsService: GoogleAnalyticsService) {
    super(googleAnalyticsService);
  }

  changeVisibilityAoi(filterSelected: ITypeFilter, project: IProjectAOI, checked: boolean) {
    if (checked && !filterSelected.checked) {
      filterSelected.checked = checked;
    }
    if (!checked && !this.grayskyIgnored.find((p) => p.getLayerId() === project.getLayerId())) {
      this.grayskyIgnored.push(project);
    } else if (checked) {
      this.grayskyIgnored = this.grayskyIgnored.filter((p) => p.getLayerId() !== project.getLayerId());
    }

    super.changeVisibilityAoi(filterSelected, project, checked);
  }

  /**
   * Use filters to send to parent controller and handle projects(aoi) visibility
   */
  applyFilters(emmit: boolean = true) {
    FilterProjectService.resetFiltersCount(this.filters);
    const projects = this.viewerService.filterProjectsByFilter(this.filters);

    this.visible = projects.visible;
    this.projects = projects.hidden;

    this.grayskyAvailable = [
      ...this.visible.filter((p) => p.isEnabled() && p.isGraySky()),
      ...this.projects.filter((p) => p.isEnabled() && p.isGraySky()),
    ];
    // if we have some graysky ignored we modify the list received before send to apply
    if (this.grayskyIgnored?.length) {
      projects.visible = projects.visible.filter(
        (p: IProjectAOI) => !this.grayskyIgnored.some((g) => g.getLayerId() === p.getLayerId()),
      );
      this.grayskyIgnored.forEach((g) => projects.hidden.push(g));
    }
    this.enabled = this.filters.isEnabled();
    if (emmit) {
      const event = {
        filters: this.filters,
        projects: projects,
      };

      this.onUpdateProjects.emit(event);
    }

    //update visible counter after apply
    FilterProjectService.processAfterFilter(this.visible, this.filters);
  }
}
